import React from 'react';
import { connect } from 'react-redux';
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';
import { getParams, downloadCSV } from 'actions/stats';
import { chainGetPNG, dumpAllToPDF } from "./functions"

class NewWidgetExport extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            loading: false
        };

    }
    downloadCSV() {
        this.setState({ loading: true }, () => {
            downloadCSV(this.props.node, this.props.querySettings, () => {
                this.setState({ loading: false })
            })
        })
    }
    downloadPDF() {
        this.setState({ loading: true }, () => {
            var images = [];
            chainGetPNG([
                this.props.widget
            ], images,
                () => {
                    this.setState({ loading: false });
                    dumpAllToPDF(images, this.getPDFName());
                });
        });
    }

    getPDFName() {
        let settings = getParams({
            querySettings: this.props.querySettings,
            currentNode: this.props.node
        });
        let locationName = this.props.tree.info.name.replace(/[^A-Za-z0-9]/g, '');
        return `WIDGET_${locationName}_${settings.startdate}_${settings.enddate}_${settings.starthour}:00_${settings.endhour}:59.pdf`;
    }
    render() {
        return (
            <React.Fragment>

                <Dropdown className={this.props.className} header={
                    <div style={{ display: "block" }} data-tooltip={"Export data"}>
                        <div className={"text-center widget-export display--flex__flex--center " + (this.state.loading ? "loading" : "")}>
                            {this.state.loading ?
                                <img src="src/assets/icons/loading.gif" />
                                :
                                <span className="font-icon icon-export" />
                            }
                        </div>
                    </div>
                } toggleable={!this.state.loading} noArrow>
                    <DropdownItem>
                        <div onClick={() => this.downloadCSV()}>
                            CSV : Data of sensors
                        </div>
                    </DropdownItem>
                    <DropdownItem>
                        <div onClick={() => this.downloadPDF()}>
                            PDF : Picture of widget
                        </div>
                    </DropdownItem>
                </Dropdown>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        tree: state.overviewReducer.customerOverview,
        nodeMap: state.overviewReducer.nodeMap,
        querySettings: state.querySettingsReducer,
        cards: state.defaultSettingsReducer.card
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewWidgetExport);


// WEBPACK FOOTER //
// ./src/components/common/dropdowncomponents/dataexportdropdown/widgetexport.jsx